/* eslint-disable jsx-a11y/anchor-is-valid */
import {
  AdminSelect,
  Button,
  Div,
  H3,
  H5,
  P,
  Separator,
  TextWithTooltipIcon,
  VDriveLogo,
  VDrivePaymentMode,
  VDrivePaymentModeOptions,
} from '@vgrubs/components';
import { Dispatch, SetStateAction } from 'react';

export const autoRechargeAmounts = [
  { name: '$25', value: 2500 },
  { name: '$50', value: 5000 },
  { name: '$100', value: 10000 },
  { name: '$200', value: 20000 },
  { name: '$500', value: 50000 },
  { name: '$1000', value: 100000 },
];

const typeOptions = (
  <optgroup label="Select Amount">
    {autoRechargeAmounts.map((r, i) => (
      <option value={r.value} key={i}>
        {r.name}
      </option>
    ))}
  </optgroup>
);

export const AutoRechargeComponent = ({
  autoRechargeAmount,
  setAutoRechargeAmount,
}) => (
  <Div $flex $between $alignCenter $width="100%">
    <TextWithTooltipIcon
      text="Auto Recharge Card with"
      tooltip="The dollar amount deposited when your card is topped up automatically."
    />

    <Div $width="120px">
      <AdminSelect
        value={autoRechargeAmount}
        options={typeOptions}
        onChange={({ target }) => setAutoRechargeAmount(target.value)}
      />
    </Div>
  </Div>
);

export const AutoRechargeWhenComponent = ({
  autoRechargeWhenAmount,
  setAutoRechargeWhenAmount,
}: {
  autoRechargeWhenAmount: number | null;
  setAutoRechargeWhenAmount: Dispatch<SetStateAction<number | null>>;
}) => (
  <Div $flex $between $alignCenter $width="100%">
    <TextWithTooltipIcon
      text="When vDrive Balance Goes Lower Than"
      tooltip="The minimum dollar amount that your vDrive balance must have in it before it is automatically topped up."
    />

    <Div $width="120px">
      <AdminSelect
        value={autoRechargeWhenAmount ?? ''}
        options={typeOptions}
        onChange={({ target }) =>
          setAutoRechargeWhenAmount(Number(target.value))
        }
      />
    </Div>
  </Div>
);

export const SetAutoRecharge = ({
  paymentMode,
  setPaymentMode,
  autoRechargeAmount,
  setAutoRechargeAmount,
  autoRechargeWhenAmount,
  setAutoRechargeWhenAmount,
  handleSubmitVDrive,
}: {
  paymentMode: VDrivePaymentMode;
  setPaymentMode: (mode: VDrivePaymentMode) => void;
  autoRechargeAmount: number;
  setAutoRechargeAmount: Dispatch<SetStateAction<number>>;
  autoRechargeWhenAmount: number | null;
  setAutoRechargeWhenAmount: Dispatch<SetStateAction<number | null>>;
  handleSubmitVDrive: () => void;
}) => {
  const topUp = paymentMode === VDrivePaymentMode.topUp;

  return (
    <Div $flex $column $alignCenter>
      <Div $flex $center>
        <VDriveLogo />
      </Div>
      <H3 $center $m="40px 0">
        <span>How The Client Pays</span>
      </H3>
      <P $center $mb="32">
        Choose how the client&apos;s card pays for vDrive deliveries. It can be
        changed later on Manage vDrive Location.
      </P>

      <VDrivePaymentModeOptions
        value={paymentMode}
        onChange={setPaymentMode}
        topUpAmount={Number(autoRechargeAmount)}
      />

      {/* Per delivery the amounts are still sent, kept for a later switch
          to top-up, but there is nothing to pick. */}
      {topUp && (
        <>
          <H5 $center $m="32px 0 16px 0">
            Keep Client’s Balance Topped Up
          </H5>

          <AutoRechargeComponent
            autoRechargeAmount={autoRechargeAmount}
            setAutoRechargeAmount={setAutoRechargeAmount}
          />

          <Separator $m="8px 0" />

          <AutoRechargeWhenComponent
            autoRechargeWhenAmount={autoRechargeWhenAmount}
            setAutoRechargeWhenAmount={setAutoRechargeWhenAmount}
          />
        </>
      )}

      <Button
        $selected
        $w="100%"
        $wSM="100%"
        $mt="50"
        onClick={handleSubmitVDrive}
      >
        {topUp ? 'Confirm & Add Balance' : 'Confirm'}
      </Button>
    </Div>
  );
};
